import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class CompoundService {

constructor(private http:HttpClient) { }

search(key){
  return this.http.get<any[]>(environment.apiUrl+'compound/search?key='+key);
}

getCompounds(){
  return this.http.get<any[]>(environment.apiUrl+"compound");
}

addCompounds(model:any){
return this.http.post(environment.apiUrl+"compound",model);
}

editCompounds(model:any,id:any){
  return this.http.put(environment.apiUrl+"compound/"+id,model);
  }

deleteCompounds(id:any){
  return this.http.delete(environment.apiUrl+"compound/"+id);
  }

}
